export default __webpack_public_path__ + "static/media/luxuru.7804c5d9.jpg";